import { Direction } from '@mui/material';

export enum SiteLocale {
  EN = 'en',
  AR = 'ar',
}

export const DEFAULT_LOCALE = SiteLocale.EN;
export const DEFAULT_DIRECTION = 'ltr';
export const DIRECTION_LOOKUP: { [key in string]: Direction } = {
  en: 'ltr',
  ar: 'rtl',
};

// Languages from DatoCMS should include country information
export const INTL_LOCALE_MAP = {
  en: 'en-GB',
  // Uses latin numbers, arabic numbers causes issues with hydration on safari
  ar: 'ar-SA-u-nu-latn',
};

// Event days start at 6am and end at 6am
export const EVENT_DAY_HOUR_OFFSET = 6.0;
